package com.ijoin.data.api

import com.ijoin.data.model.AppVersionResponse
import io.ktor.client.call.*
import io.ktor.client.request.*
import io.ktor.http.*

object AppVersionApi {

    suspend fun checkVersion(platform: String, currentVersion: String): Result<AppVersionResponse> {
        return try {
            val url = "${ApiClient.getBaseUrl()}/api/app/version"
            println("[AppVersionApi] GET $url?platform=$platform&currentVersion=$currentVersion")

            val response = ApiClient.client.get(url) {
                parameter("platform", platform)
                parameter("currentVersion", currentVersion)
                contentType(ContentType.Application.Json)
            }

            println("[AppVersionApi] Response status: ${response.status}")

            if (response.status.isSuccess()) {
                Result.success(response.body<AppVersionResponse>())
            } else {
                val errorBody = try { response.body<String>() } catch (e: Exception) { "no body" }
                println("[AppVersionApi] Error body: $errorBody")
                Result.failure(ApiException(response.status, "Failed to check version: ${response.status} - $errorBody"))
            }
        } catch (e: Exception) {
            println("[AppVersionApi] Exception: ${e.message}")
            Result.failure(e)
        }
    }
}
